export function encodeForCSV(cellValue) {
  if (!cellValue) return "";
  // If the cell value contains double quotes, double them
  if (typeof cellValue === "string" && cellValue.includes('"')) {
    cellValue = cellValue.replace(/"/g, '""');
  }
  if (typeof cellValue === "string") cellValue = cellValue.replace(/[\r\n]+/g, " ");
  cellValue = `"${cellValue}"`;

  return cellValue;
}



// WEBPACK FOOTER //
// ./src/utils/csvFormatter.js